var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 13.25C7.76953 13.25 4.875 10.3555 4.875 6.75C4.875 3.19531 7.76953 0.25 11.375 0.25C14.9297 0.25 17.875 3.19531 17.875 6.75C17.875 10.3555 14.9297 13.25 11.375 13.25ZM9.03906 15.6875H13.6602C18.6875 15.6875 22.75 19.75 22.75 24.7773C22.75 25.5898 22.0391 26.25 21.2266 26.25H1.47266C0.660156 26.25 0 25.5898 0 24.7773C0 19.75 4.01172 15.6875 9.03906 15.6875Z",
    fill: "#BC6C25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 13.25C7.76953 13.25 4.875 10.3555 4.875 6.75C4.875 3.19531 7.76953 0.25 11.375 0.25C14.9297 0.25 17.875 3.19531 17.875 6.75C17.875 10.3555 14.9297 13.25 11.375 13.25ZM9.03906 15.6875H13.6602C18.6875 15.6875 22.75 19.75 22.75 24.7773C22.75 25.5898 22.0391 26.25 21.2266 26.25H1.47266C0.660156 26.25 0 25.5898 0 24.7773C0 19.75 4.01172 15.6875 9.03906 15.6875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.4fa95409eeef432d3c6e41f72a9f1104.svg";
export { ForwardRef as ReactComponent };